// extracted by mini-css-extract-plugin
module.exports = {"list":"_1Yup2o","item":"_3LRxuE","card":"_3mclim","center":"ViO9Ss","container":"_2Rr7Kp","shine-lines":"_3Sko1U"};